import React from 'react';
import classNames from 'classnames/bind';
import styles from './TitleUnderText.scss';
// import TextareaAutosize from '@material-ui/core/TextareaAutosize';

const cx = classNames.bind(styles);

const TitleUnderText = ({
  text,
  padding,
  color,
  fontSize,
  height,
  align,
  bgColor,
  margin,
  style,
  colorText,
  textAlign,
}) => {
  const defaultText = text ? text.split('\n') : [];
  const crText = colorText ? colorText.split('\n') : [];
  // console.log({ textAlign });
  return (
    <div
      className={cx('TitleUnderText')}
      style={{ backgroundColor: bgColor, margin: margin }}
    >
      <p
        style={{
          color: color,
          fontSize: fontSize,
          lineGeight: height,
          padding: padding,
          textAlign: textAlign,
        }}
        dangerouslySetInnerHTML={{
          __html: defaultText.join('<br/>'),
        }}
      />

      <p
        className="color"
        style={{ textAlign: textAlign }}
        dangerouslySetInnerHTML={{
          __html: crText.join('<br/>'),
        }}
      />
    </div>
  );
};

export default TitleUnderText;
